import styled, { css } from "styled-components";


export const MainWrapper = styled.div`
  padding: 18px 18px 26px;
  background: #f6f7fb;
  min-height: calc(100vh - 64px);

  input[type="checkbox"] {
    accent-color: #2563eb;
  }

  .btn-outline-secondary:hover {
    background: #f3f6ff;
    border-color: rgba(37, 99, 235, 0.35);
    color: #1f2937;
  }
`;

export const MainContent = styled.div`
  background: #ffffff;
  border: 1px solid #e9ecf3;
  border-radius: 14px;
  padding: 18px;
  margin-top: 14px;
  box-shadow: 0 6px 18px rgba(20, 20, 43, 0.06);
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;

  h3 {
    font-size: 18px;
    margin: 0;
    color: #111827;
    font-weight: 700;
    letter-spacing: -0.2px;
  }

  p {
    margin: 6px 0 0;
    font-size: 13px;
  }
`;

export const TableWrap = styled.div`
  border: 1px solid #eef0f6;
  border-radius: 12px;
  background: #fff;

  overflow: auto;
  max-height: calc(100vh - 260px);

  position: relative;
  isolation: isolate;

  table {
    margin-bottom: 0;
    border-collapse: separate; /* ajuda com bleed */
    border-spacing: 0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 10;              /* mais alto que o conteúdo */
    background: #f8fafc;      /* fundo sólido */
    background-clip: padding-box;
  }

  /* cria uma “linha” fixa embaixo do header pra não parecer vazado */
  thead th::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 1px;
    background: #e5e7eb;
  }
`;

export const AdminTable = styled.table`
  width: 100%;
  margin: 0;
  border-collapse: separate;
  border-spacing: 0;

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #f8fafc;
    color: #374151;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    border-bottom: 1px solid #eef0f6;
    padding: 12px 12px;
    vertical-align: middle;
  }

  tbody td {
    border-bottom: 1px solid #f0f2f7;
    padding: 12px 12px;
    vertical-align: middle;
    color: #111827;
    font-size: 14px;
  }

  tbody tr {
    transition: background 0.12s ease;
  }

  tbody tr:hover {
    background: #fbfbff;
  }

  tbody tr:nth-child(even) {
    background: #fcfdff;
  }

  .col-tema {
    min-width: 380px;
  }

  .col-check {
    min-width: 120px;
    text-align: center;
  }

  .col-actions {
    min-width: 260px;
    text-align: right;
    white-space: nowrap;
  }
`;

export const TemaTitle = styled.div`
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
`;

export const TemaMeta = styled.div`
  margin-top: 4px;
  color: #6b7280;
  font-size: 12px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  color: #374151;
  background: #f3f4f6;
  border: 1px solid #eceff5;
`;

export const CheckCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .form-check {
    margin: 0;
    padding-left: 0;
    min-height: auto;
  }

  .form-check-input {
    width: 18px;
    height: 18px;
    cursor: pointer;
    border-radius: 6px;
    border: 1px solid #d4d8e3;
  }

  .form-check-input:focus {
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.18);
    border-color: #93c5fd;
  }
`;

export const Actions = styled.div`
  display: inline-flex;
  gap: 8px;
  align-items: center;

  .btn {
    border-radius: 10px;
    font-weight: 600;
    font-size: 13px;
    padding: 8px 12px;
  }

  .btn-outline-secondary {
    border-color: #e5e7eb;
    color: #374151;
    background: #ffffff;
  }

  .btn-outline-secondary:hover {
    background: #f8fafc;
    border-color: #d1d5db;
  }

  .btn-primary {
    box-shadow: 0 10px 20px rgba(37, 99, 235, 0.18);
  }
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const SmallHint = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

export const Divider = styled.div`
  height: 1px;
  background: #eef0f6;
  margin: 14px 0 0;
`;

export const HeaderCard = styled.div`
  background: #fff;
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 14px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const HeaderLeft = styled.div`
  h3 {
    margin: 0;
    font-weight: 700;
    color: #1f2937;
  }
  p {
    margin: 4px 0 0;
    color: #6b7280;
    font-size: 13px;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  button {
    height: 34px;
    padding: 0 12px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 13px;
  }
`;

export const MetaRow = styled.div`
  margin-top: 6px;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

export const Chip = styled.span`
  background: #f3f4f6;
  color: #374151;
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 999px;
  padding: 3px 8px;
  font-size: 11px;
`;

export const CenterCell = styled.td`
  text-align: center;

  .form-check {
    display: flex;
    justify-content: center;
    margin: 0;
  }

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`;

export const ActionsCell = styled.td`
  text-align: center;

  .btn {
    border-radius: 8px;
    font-weight: 600;
    font-size: 12px;
    padding: 6px 10px;
  }
`;

export const IconBtn = styled.button`
  width: 22px;
  height: 22px;
  border-radius: 7px;
  border: 1px solid rgba(37, 99, 235, 0.35);
  background: transparent;
  color: rgb(37, 99, 235);
  font-weight: 800;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  transition: transform 0.08s ease, background 0.12s ease, border-color 0.12s ease;

  &:hover:not(:disabled) {
    background: rgba(37, 99, 235, 0.12);
    border-color: rgba(37, 99, 235, 0.55);
    transform: translateY(-0.5px);
  }

  &:active:not(:disabled) {
    transform: translateY(0px);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.22);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

